import { gql } from '@apollo/client'

export const EXPORT_SOURCES_QUERY = gql`
  query Sources($first: Int, $after: String) {
    sources(first: $first, after: $after) {
      nodes {
        id
        sourceId
        name
        created
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
